export const MKTING_FORMS: any[] = [
    {
        "statusCode" : 200,
        "statusDescription" : "OK",
        "successMessage" : "OK",
        "data" : {
          "formData" : {
            "fieldSets" : [ {
              "fieldSetName" : "Default",
              "fields" : [ "workEffortTypeId", "description", "estimatedStartDate", "contentId", "contentName", "contentTypeId", "productId", "productName" ]
            } ],
            "columns" : [ {
              "name" : "workEffortTypeId",
              "title" : "Work Effort Type ID"
            }, {
              "name" : "description",
              "title" : "Description"
            }, {
              "name" : "estimatedStartDate",
              "title" : "Estimated Start Date"
            }, {
              "name" : "contentName",
              "title" : "Content Name"
            }, {
              "name" : "contentTypeId",
              "title" : "Content Type ID"
            }, {
              "name" : "productName",
              "title" : "Product Name"
            } ],
            "formName" : "ListCurrentMonthSocialPosts",
            "altTarget" : [ ],
            "formLocation" : "component://kwikstore/widget/MarketingForms.xml",
            "type" : "list",
            "fields" : [ {
              "conditionGroup" : "",
              "name" : "workEffortId",
              "action" : "",
              "id" : "ListCurrentMonthSocialPosts_workEffortId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "conditionGroup" : "",
              "name" : "contentId",
              "action" : "",
              "id" : "ListCurrentMonthSocialPosts_contentId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "conditionGroup" : "",
              "name" : "productId",
              "action" : "",
              "id" : "ListCurrentMonthSocialPosts_productId",
              "type" : "HIDDEN",
              "event" : "",
              "value" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "20",
              "ajaxUrl" : "",
              "maxlength" : "20",
              "tabindex" : "",
              "className" : "",
              "title" : "Work Effort Type ID",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "workEffortTypeId",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "ListCurrentMonthSocialPosts_workEffortTypeId",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "60",
              "ajaxUrl" : "",
              "maxlength" : "250",
              "tabindex" : "",
              "className" : "",
              "title" : "Description",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "description",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "ListCurrentMonthSocialPosts_description",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "classString" : "",
              "shortDateInput" : "false",
              "ampmName" : "",
              "className" : "",
              "title" : "Estimated Start Date",
              "type" : "DATE_TIME",
              "dateType" : "timestamp",
              "defaultDateTimeString" : "2025-02-01%2000:00:00.000",
              "timeDropdown" : "",
              "alert" : "false",
              "timeValues" : "",
              "formName" : "ListCurrentMonthSocialPosts",
              "timeDropdownParamName" : "estimatedStartDate",
              "timeMinutesName" : "",
              "disabled" : "false",
              "id" : "ListCurrentMonthSocialPosts_estimatedStartDate",
              "event" : "",
              "value" : "2025-02-01 00:00:00.000",
              "pmSelected" : "",
              "localizedInputTitle" : "",
              "mask" : "",
              "hour1" : "0",
              "isTwelveHour" : "false",
              "fieldHelpText" : "",
              "hour2" : "0",
              "maxlength" : "30",
              "minutes" : "0",
              "tabindex" : "",
              "amSelected" : "",
              "size" : "25",
              "isXMLHttpRequest" : "false",
              "localizedIconTitle" : "",
              "timeHourName" : "",
              "name" : "estimatedStartDate",
              "style" : "",
              "step" : "1",
              "compositeType" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "60",
              "ajaxUrl" : "",
              "maxlength" : "250",
              "tabindex" : "",
              "className" : "",
              "title" : "Content Name",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "contentName",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "ListCurrentMonthSocialPosts_contentName",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "20",
              "ajaxUrl" : "",
              "maxlength" : "20",
              "tabindex" : "",
              "className" : "",
              "title" : "Content Type ID",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "contentTypeId",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "ListCurrentMonthSocialPosts_contentTypeId",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            }, {
              "" : "",
              "fieldHelpText" : "",
              "textSize" : "40",
              "ajaxUrl" : "",
              "maxlength" : "60",
              "tabindex" : "",
              "className" : "",
              "title" : "Product Name",
              "type" : "TEXT",
              "clientAutocomplete" : "true",
              "ajaxEnabled" : true,
              "readonly" : false,
              "alert" : "false",
              "name" : "productName",
              "action" : "",
              "style" : "",
              "disabled" : false,
              "id" : "ListCurrentMonthSocialPosts_productName",
              "placeholder" : "",
              "event" : "",
              "value" : "",
              "mask" : ""
            } ],
            "target" : ""
          },
          "responseMessage" : "success"
        }
      },
    {

          "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "estimatedStartDate", "workEffortTypeId", "submit" ]
          } ],
          "formName" : "createSocialMediaProductPost",
          "altTarget" : [ ],
          "formLocation" : "component://kwikstore/widget/MarketingForms.xml",
          "type" : "single",
          "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "createSocialMediaProductPost_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
          }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Estimated Start Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2025-03-02%2008:33:55.233",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "createSocialMediaProductPost",
            "timeDropdownParamName" : "estimatedStartDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "createSocialMediaProductPost_estimatedStartDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "estimatedStartDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
          }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Work Effort Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "createSocialMediaProductPost",
            "options" : [ {
              "description" : "Facebook Product Post",
              "key" : "FACEB_PROD_POST"
            }, {
              "description" : "X(Twitter) Product Post",
              "key" : "X_PROD_POST"
            }, {
              "description" : "Instagram Product Post",
              "key" : "INSTA_PROD_POST"
            }, {
              "description" : "LinkedIN Product Post",
              "key" : "LINK_PROD_POST"
            }, {
              "description" : "Facebook Article Post",
              "key" : "FACEB_ART_POST"
            }, {
              "description" : "X(Twitter) Article Post",
              "key" : "X_ART_POST"
            }, {
              "description" : "Instagram Article Post",
              "key" : "INSTA_ART_POST"
            }, {
              "description" : "LinkedIN Article Post",
              "key" : "LINK_ART_POST"
            } ],
            "disabled" : "false",
            "id" : "createSocialMediaProductPost_workEffortTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "workEffortTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
          }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "createSocialMediaProductPost",
            "tabindex" : "",
            "name" : "submit",
            "className" : "",
            "id" : "createSocialMediaProductPost_submit",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Find",
            "event" : "",
            "imgSrc" : ""
          } ],
          "target" : "createSocialMediaProductPost"

    },
  {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "estimatedStartDate", "workEffortTypeId", "submit" ]
        } ],
        "formName" : "CreateSocialMediaProductPost",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/MarketingForms.xml",
        "type" : "single",
        "fields" : [ {
          "fieldHelpText" : "",
          "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "productId","internalName","description","brandName" ],
            "className" : "",
            "type" : "LOOKUP",
            "entityName":"Product",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "CreateSocialMediaProductPost",
            "id" : "CreateSocialMediaProductPost_productId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupProduct",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "productId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
          },
          "name" : "productId",
          "style" : "",
          "id" : "CreateSocialMediaProductPost_productId",
          "title" : "Product ID",
          "type" : "LOOKUP"
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Estimated Start Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2025-03-11%2019:25:58.496",
          "timeDropdown" : "text",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "CreateSocialMediaProductPost",
          "timeDropdownParamName" : "estimatedStartDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "CreateSocialMediaProductPost_estimatedStartDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "estimatedStartDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "fieldName" : "",
          "firstInList" : "",
          "partialChars" : "",
          "conditionGroup" : "",
          "otherFieldName" : "",
          "className" : "",
          "title" : "Post Type",
          "type" : "DROP_DOWN",
          "frequency" : "",
          "minChars" : "",
          "allowEmpty" : "",
          "autoSelect" : "",
          "ajaxEnabled" : "false",
          "noCurrentSelectedKey" : "",
          "ajaxOptions" : "",
          "alert" : "false",
          "otherFieldSize" : "0",
          "ignoreCase" : "",
          "formName" : "CreateSocialMediaProductPost",
          "options" : [ {
            "description" : "Facebook Product Post",
            "key" : "FACEB_PROD_POST"
          }, {
            "description" : "X(Twitter) Product Post",
            "key" : "X_PROD_POST"
          }, {
            "description" : "Instagram Product Post",
            "key" : "INSTA_PROD_POST"
          }, {
            "description" : "LinkedIN Product Post",
            "key" : "LINK_PROD_POST"
          }, {
            "description" : "Facebook Article Post",
            "key" : "FACEB_ART_POST"
          }, {
            "description" : "X(Twitter) Article Post",
            "key" : "X_ART_POST"
          }, {
            "description" : "Instagram Article Post",
            "key" : "INSTA_ART_POST"
          }, {
            "description" : "LinkedIN Article Post",
            "key" : "LINK_ART_POST"
          } ],
          "disabled" : "false",
          "id" : "CreateSocialMediaProductPost_workEffortPurposeTypeId",
          "event" : "",
          "otherValue" : "",
          "fullSearch" : "",
          "fieldHelpText" : "",
          "dDFCurrent" : "selected",
          "tabindex" : "",
          "multiple" : "",
          "partialSearch" : "",
          "size" : "1",
          "name" : "workEffortPurposeTypeId",
          "style" : "",
          "explicitDescription" : "",
          "choices" : "",
          "currentValue" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "CreateSocialMediaProductPost",
          "tabindex" : "",
          "name" : "submit",
          "className" : "",
          "id" : "CreateSocialMediaProductPost_submit",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Find",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "createSocialMediaProductPost",
        "targets":{
          createTarget:"createSocialMediaProductPost",
          updateTarget:"updateSocialMediaProductPost"
        }
  },
    {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "estimatedStartDate", "workEffortTypeId", "submit" ]
        } ],
        "formName" : "createSocialMediaProductPost",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/MarketingForms.xml",
        "type" : "single",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "productId",
          "action" : "",
          "id" : "createSocialMediaProductPost_productId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Estimated Start Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2025-03-02%2008:47:25.966",
          "timeDropdown" : "text",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "createSocialMediaProductPost",
          "timeDropdownParamName" : "estimatedStartDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "createSocialMediaProductPost_estimatedStartDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "View Calendar",
          "timeHourName" : "",
          "name" : "estimatedStartDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "fieldName" : "",
          "firstInList" : "",
          "partialChars" : "",
          "conditionGroup" : "",
          "otherFieldName" : "",
          "className" : "",
          "title" : "Work Effort Type ID",
          "type" : "DROP_DOWN",
          "frequency" : "",
          "minChars" : "",
          "allowEmpty" : "",
          "autoSelect" : "",
          "ajaxEnabled" : "false",
          "noCurrentSelectedKey" : "",
          "ajaxOptions" : "",
          "alert" : "false",
          "otherFieldSize" : "0",
          "ignoreCase" : "",
          "formName" : "createSocialMediaProductPost",
          "options" : [ {
            "description" : "Facebook Product Post",
            "key" : "FACEB_PROD_POST"
          }, {
            "description" : "X(Twitter) Product Post",
            "key" : "X_PROD_POST"
          }, {
            "description" : "Instagram Product Post",
            "key" : "INSTA_PROD_POST"
          }, {
            "description" : "LinkedIN Product Post",
            "key" : "LINK_PROD_POST"
          }, {
            "description" : "Facebook Article Post",
            "key" : "FACEB_ART_POST"
          }, {
            "description" : "X(Twitter) Article Post",
            "key" : "X_ART_POST"
          }, {
            "description" : "Instagram Article Post",
            "key" : "INSTA_ART_POST"
          }, {
            "description" : "LinkedIN Article Post",
            "key" : "LINK_ART_POST"
          } ],
          "disabled" : "false",
          "id" : "createSocialMediaProductPost_workEffortTypeId",
          "event" : "",
          "otherValue" : "",
          "fullSearch" : "",
          "fieldHelpText" : "",
          "dDFCurrent" : "selected",
          "tabindex" : "",
          "multiple" : "",
          "partialSearch" : "",
          "size" : "1",
          "name" : "workEffortTypeId",
          "style" : "",
          "explicitDescription" : "",
          "choices" : "",
          "currentValue" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "createSocialMediaProductPost",
          "tabindex" : "",
          "name" : "submit",
          "className" : "",
          "id" : "createSocialMediaProductPost_submit",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "Find",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "createSocialMediaProductPost",
        "targets":{
        createTarget:"createContent",
        updateTarget:"updateContent"
      },
  },
  {
      "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "workEffortTypeId", "description", "estimatedStartDate", "workEffortPurposeTypeId", "contentId", "contentName", "contentTypeId", "productId", "productName", "metaDataPredicateId", "metaDataValue", "metaDataPredicateId1", "metaDataValue1", "metaDataPredicateId2", "metaDataValue2" ]
      } ],
      "columns" : [ {
        "name" : "WorkEffortId",
        "title" : "Work Effort ID"
      }, {
        "name" : "workEffortTypeId",
        "title" : "Work Effort Type ID"
      }, {
        "name" : "description",
        "title" : "Description"
      }, {
        "name" : "estimatedStartDate",
        "title" : "Estimated Start Date"
      }, {
        "name" : "workEffortPurposeTypeId",
        "title" : "Work Effort Purpose Type ID"
      }, {
        "name" : "contentId",
        "title" : "Content ID"
      }, {
        "name" : "contentName",
        "title" : "Content Name"
      }, {
        "name" : "contentTypeId",
        "title" : "Content Type ID"
      }, {
        "name" : "productId",
        "title" : "Product ID"
      }, {
        "name" : "productName",
        "title" : "Product Name"
      }, {
        "name" : "metaDataPredicateId",
        "title" : "Meta Data Predicate ID"
      }, {
        "name" : "metaDataValue",
        "title" : "Meta Data Value"
      }, {
        "name" : "metaDataPredicateId1",
        "title" : "Meta Data Predicate Id1"
      }, {
        "name" : "metaDataValue1",
        "title" : "Meta Data Value1"
      }, {
        "name" : "metaDataPredicateId2",
        "title" : "Meta Data Predicate Id2"
      }, {
        "name" : "metaDataValue2",
        "title" : "Meta Data Value2"
      } ],
      "formName" : "ScheduledSocialMediaPosts",
      "altTarget" : [ ],
      "formLocation" : "component://kwikstore/widget/MarketingForms.xml",
      "type" : "list",
      "fields" : [ {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "WorkEffortId",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_WorkEffortId",
        "title" : "Work Effort ID",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "workEffortTypeId",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_workEffortTypeId",
        "title" : "Work Effort Type ID",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "description",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_description",
        "title" : "Description",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "estimatedStartDate",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_estimatedStartDate",
        "title" : "Estimated Start Date",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "workEffortPurposeTypeId",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_workEffortPurposeTypeId",
        "title" : "Work Effort Purpose Type ID",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "contentId",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_contentId",
        "title" : "Content ID",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "contentName",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_contentName",
        "title" : "Content Name",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "contentTypeId",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_contentTypeId",
        "title" : "Content Type ID",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "productId",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_productId",
        "title" : "Product ID",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "productName",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_productName",
        "title" : "Product Name",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "metaDataPredicateId",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_metaDataPredicateId",
        "title" : "Meta Data Predicate ID",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "metaDataValue",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_metaDataValue",
        "title" : "Meta Data Value",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "metaDataPredicateId1",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_metaDataPredicateId1",
        "title" : "Meta Data Predicate Id1",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "metaDataValue1",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_metaDataValue1",
        "title" : "Meta Data Value1",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "metaDataPredicateId2",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_metaDataPredicateId2",
        "title" : "Meta Data Predicate Id2",
        "type" : "DISPLAY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "metaDataValue2",
        "description" : "",
        "style" : "",
        "id" : "ScheduledSocialMediaPosts_metaDataValue2",
        "title" : "Meta Data Value2",
        "type" : "DISPLAY",
        "imageLocation" : ""
      } ],
      "target" : ""
  },
  {
      "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "workEffortPurposeTypeId", "estimatedStartDate" ]
      } ],
      "columns" : [ {
        "name" : "workEffortPurposeTypeId",
        "title" : "Work Effort Purpose Type ID"
      }, {
        "name" : "estimatedStartDate",
        "title" : "Estimated Start Date"
      } ],
      "formName" : "SocialMediaCurrentPostingList",
      "altTarget" : [ ],
      "formLocation" : "component://kwikstore/widget/MarketingForms.xml",
      "type" : "list",
      "fields" : [ {
        "conditionGroup" : "",
        "name" : "workEffortId",
        "action" : "",
        "id" : "SocialMediaCurrentPostingList_workEffortId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "workEffortPurposeTypeId",
        "description" : "",
        "style" : "",
        "id" : "SocialMediaCurrentPostingList_workEffortPurposeTypeId",
        "title" : "Work Effort Purpose Type ID",
        "type" : "DISPLAY_ENTITY",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "estimatedStartDate",
        "description" : "",
        "style" : "",
        "id" : "SocialMediaCurrentPostingList_estimatedStartDate",
        "title" : "Estimated Start Date",
        "type" : "DISPLAY",
        "imageLocation" : ""
      } ],
      "target" : ""
  },
  {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "contentId", "estimatedStartDate", "workEffortPurposeTypeId", "title", "description", "uploadedFile","image", "submit" ]
        } ],
        "formName" : "UpdateSocialMediaPost",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/MarketingForms.xml",
        "type" : "single",
        "fields" : [ {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "workEffortId",
          "description" : "",
          "style" : "",
          "id" : "UpdateSocialMediaPost_workEffortId",
          "title" : "Work Effort ID",
          "type" : "HIDDEN",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "contentId",
          "description" : "10779",
          "style" : "",
          "id" : "UpdateSocialMediaPost_contentId",
          "title" : "Content ID",
          "type" : "HIDDEN",
          "imageLocation" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Estimated Start Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2025-03-15%2023:00:00.000",
          "timeDropdown" : "text",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "UpdateSocialMediaPost",
          "timeDropdownParamName" : "estimatedStartDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "UpdateSocialMediaPost_estimatedStartDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "",
          "timeHourName" : "",
          "name" : "estimatedStartDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "workEffortPurposeTypeId",
          "description" : "Facebook Product Post",
          "style" : "",
          "id" : "UpdateSocialMediaPost_workEffortPurposeTypeId",
          "title" : "Work Effort Purpose Type ID",
          "type" : "DISPLAY_ENTITY",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "title",
          "description" : "Square Gizmo",
          "style" : "",
          "id" : "UpdateSocialMediaPost_title",
          "title" : "Title",
          "type" : "DISPLAY",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "description",
          "description" : "A square gizmo",
          "style" : "",
          "id" : "UpdateSocialMediaPost_description",
          "title" : "Description",
          "type" : "DISPLAY",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "maxlength" : "",
          "autocomplete" : "",
          "tabindex" : "",
          "className" : "",
          "title" : "Picture",
          "type" : "FILE",
          "size" : "25",
          "alert" : "false",
          "name" : "uploadedFile",
          "style" : "",
          "id" : "UpdateSocialMediaPost_uploadedFile",
          "value" : ""
      },{
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "image",
          "description" : "/images/products/GZ-2002/additional5/1200x630.jpg",
          "style" : "",
          "id" : "UpdateSocialMediaPost_image",
          "title" : "Image",
          "type" : "HIDDEN",
          "imageLocation" : ""
        }, {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "UpdateSocialMediaPost",
          "tabindex" : "",
          "name" : "submit",
          "className" : "",
          "id" : "UpdateSocialMediaPost_submit",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "updateSocialMediaPost",
        "targets":{
          createTarget:"createSocialMediaProductPost",
          updateTarget:"updateSocialMediaPost"
        }
  }
]
